var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3 13.9h-4.1c-1.1 0-2.1.9-2.1 2s.9 2 2.1 2h2.1v20.8H9.4V18h2c1.1 0 2.1-.9 2.1-2s-.9-2-2.1-2H7.3c-1.1 0-2.1.9-2.1 2v24.8c0 1.1.9 2 2.1 2h29c1.1 0 2.1-.9 2.1-2V16.1c.1-1.3-.9-2.2-2.1-2.2zM17.4 11l2.3-2.3v19.6c0 1.1.9 2 2.1 2s2.1-.9 2.1-2V8.7l2.3 2.3c.8.8 2.1.8 2.9 0s.8-2.1 0-2.9l-6-5.8c-.5-.5-.9-.6-1.4-.6-.5 0-1.1.2-1.4.6l-6 5.8c-.8.8-.8 2.1 0 2.9 1.1.8 2.3.8 3.1 0z"
  })));
};
export default SvgShare;